import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Grid, AppBar, Tabs, Tab, Box } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views'; // 可以快速渲染第一張幻燈片，然後延遲加載
import PropTypes from 'prop-types';

/**
 * @description Tab 組件
 * @param {boolean} disableRipple 禁用點擊漣漪效果 
 * @param {string} indicatorColor 主顏色
 * @param {string} textColor 文字顏色
 * @param {string} scrollButtons 滾動 Tab 的按鈕 'auto' | 'desktop' | 'off' | 'on'
 * @param {string} variant Tab 的按鈕顯示形式 'fullWidth' | 'scrollable' | 'standard' 
 * @param {string} activeTabNumber Tab 預設active的頁面
 */
function FullWidthTabs(props) {
    const theme = useTheme();
    const [value, setValue] = React.useState(props.activeTabNumber ? props.activeTabNumber : 0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const childrenWithAdditionProps = () => {
        return this.props.tabsData.map((tab) => ({
            ...tab,
            content: React.cloneElement(tab.content, { enqeueSnackbar: this.props.enqeueSnackbar, responseError: this.props.responseError })
        }))
    }

    return (
        <Grid item lg={12} md={12} xs={12} style={{ minHeight: "16rem" }}>
            <AppBar position="static" className={"MuiTabs-colorPrimary"} style={{ borderBottom: "1px solid #ddd" }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor={props.indicatorColor}
                    textColor={props.textColor}
                    variant={props.variant}
                    scrollButtons={props.scrollButtons}
                    aria-label={props.ariaLabel}>
                    {props.tabsData.filter(item => typeof item == 'object').map((item, index) => {
                        return (<Tab
                            component={"button"}
                            key={"tab_" + index}
                            disableRipple={props.disableRipple}
                            style={{ fontSize: item.fontSize }}
                            label={item.name}
                            id={`tab-${index}`}
                            aria-controls={`tabpanel-${index}`}
                            onClick={() => { if (props.clickEvent !== undefined) props.clickEvent(index) }} />)
                    })}
                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={handleChangeIndex}>
                {props.tabsData.filter(item => typeof item == 'object').map((item, index) => (
                    <Box key={"tabpanel_" + index} value={value} index={index} dir={theme.direction}
                        style={{
                            padding: props.padding === undefined ? "24px 0" : (props.padding === "none" ? "0" : props.padding),
                            display: value === index ? "block" : "none",
                            overflow: props.overflow ? props.overflow : "none",
                            minHeight: props.boxMinHeight ? props.boxMinHeight : "35rem"
                        }}>
                        {item.content}
                    </Box>
                ))}
            </SwipeableViews>
        </Grid>
    );
}

/**
 * FullWidthTabs
 * @description 型別判斷
 */
FullWidthTabs.propTypes = {
    tabsData: PropTypes.array,
    padding: PropTypes.string,
    boxMinHeight: PropTypes.string,
    disableRipple: PropTypes.bool,
    indicatorColor: PropTypes.string,
    textColor: PropTypes.string,
    scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'off', 'on']),
    variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard']),
    ariaLabel: PropTypes.string,
    clickEvent:PropTypes.func,
    activeTabNumber: PropTypes.number
}

function VerticalTabs(props) {
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid item lg={12} md={12} xs={12} style={{ flexGrow: 1, display: 'flex' }}>
            <Tabs
                orientation="vertical"
                variant={props.scrollable === undefined ? "scrollable" : props.scrollable}
                value={value}
                data-aria="vertical"
                indicatorColor={props.indicatorColor}
                textColor={props.textColor}
                onChange={handleChange}
                scrollButtons={props.scrollButtons}
                aria-label={props.ariaLabel}
                style={{
                    borderRight: `1px solid ${theme.palette.divider}`,
                    overflow: 'visible',
                }}
            >
                {props.tabsData.map((elem, index) => (
                    <Tab key={"vertical-tab_" + index}
                        component={"button"} id={"vertical-tab-" + index}
                        label={elem.name} aria-controls={"vertical-tabpanel-" + index} />
                ))}
            </Tabs>
            {props.tabsData.map((elem, index) => {
                return (
                    <div role="tabpanel" key={"vertical-tabpanel_" + index} hidden={value !== index} index={index}
                        id={"vertical-tabpanel-" + index} aria-labelledby={"vertical-tab-" + index}>
                        {elem.content}
                    </div>
                )
            })}
        </Grid>
    );
}

export {
    FullWidthTabs,
    VerticalTabs
};